import { useState } from 'react'
import { PiCirclesThreePlus } from 'react-icons/pi'

import { CompanyHeader } from './CompanyHeader'
import { Tabs } from '../../Tabs'
import { CompanySidebarFooter } from './CompanySidebarFooter'
import { CustomCompanySidebarFooter } from './CustomCompanySidebarFooter'
import { cn } from 'components/UI/cn'
import type { CompanySidebarHeader, SidebarTabConfig } from './index'

interface SidebarContentProps {
  chainProxyId: number
  header: CompanySidebarHeader
  tabs: SidebarTabConfig[]
  doorId?: number
  address?: string
  phone?: string
}

/**
 * Sidebar content with custom company banner, header, tabs, content area, and footer.
 */
export function SidebarContent({
  chainProxyId,
  header,
  tabs,
  doorId,
  address,
  phone,
}: SidebarContentProps) {
  const [selectedTab, setSelectedTab] = useState(tabs[0]?.key || '')

  const currentTabContent =
    tabs.find((tab) => tab.key === selectedTab)?.content || []

  return (
    <>
      {header.isUserCreated && (
        <div className="w-full absolute top-0 left-0 bg-[#710873] rounded-t-lg h-10 flex items-center justify-center text-white font-medium text-xs">
          <PiCirclesThreePlus size={16} className="mr-1" />
          Custom Company
        </div>
      )}
      <div
        className={cn('flex-shrink-0', {
          'mt-4': header.isUserCreated,
        })}
      >
        <div className="mb-[24px]">
          <CompanyHeader
            companyName={header.name}
            domain={header.domain}
            logoUrl={header.logoUrl}
            isUserCreated={header.isUserCreated}
          />
        </div>
        <div>
          <Tabs
            tabs={tabs.map((t) => ({ key: t.key, title: t.title }))}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            className="border-b border-gray-200"
          />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto min-h-0 pr-3">
        <div className="py-6 space-y-6">{currentTabContent}</div>
      </div>

      <div className="flex-shrink-0">
        {header.isUserCreated ? (
          <CustomCompanySidebarFooter chainProxyId={chainProxyId} />
        ) : (
          <CompanySidebarFooter
            chainProxyId={chainProxyId}
            companyName={header.name}
            domain={header.domain}
            doorId={doorId}
            address={address}
            phone={phone}
          />
        )}
      </div>
    </>
  )
}
